import React from "react";
import {t} from "../../../helpers/translator";

export default function lockTerminalTemplate () {
    return <div className="ticket-results-view-p">
        <h3>{t("Would you like to update this profile?")}</h3>
        <div className="buttons-view-w-t">
            <ul>
                <li>
                    <div className="separator-box-buttons-m">
                        <button className="button-view-normal-m"
                                onClick={this.updateUserInfo}>
                            {t("Yes")}
                        </button>
                    </div>
                </li>
                <li>
                    <div className="separator-box-buttons-m">
                        <button className="button-view-normal-m trans-m"
                                onClick={this.registerPopupForDms()}>
                            {t("Cancel")}
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>;
}